<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Chi tiết đơn đặt hàng</h1>
      <div class="btn-group float-right">
        <button class="btn btn-secondary" @click="cancel">Quay lại</button>
        <button
          v-if="
            dataPermission &&
            dataPermission.includes('CNPS_DEVICE_PURCHASE_ORDER_MNP_CREATE_TRANSFER_ORDER') &&
            detail?.status === 'CONFIRMED'
          "
          class="btn btn-primary"
          @click="comfirm"
        >
          Tạo điều chuyển
        </button>
        <button
          class="btn btn-primary"
          v-if="
            dataPermission &&
            dataPermission.includes('SCON_RECEIPT_AGENCY_ADD') &&
            detail?.status === 'MNP_FULFILLED' &&
            !['NEW', 'DONE', 'PENDING_SA_APPROVAL', 'PENDING_ACCOUNTANT_APPROVAL'].includes(
              detail?.orderTransferStatus
            )
          "
          @click="$router.push(`/order-form-add-receipt/${id}/${detail?.agentId}`)"
        >
          Tạo phiếu thu đối tác
        </button>
        <button
          v-if="
            dataPermission &&
            dataPermission.includes('CNPS_DEVICE_PURCHASE_ORDER_MNP_APPROVE') &&
            detail?.status === 'CONFIRMED'
          "
          class="btn btn-danger"
          @click="reject"
        >
          Từ chối
        </button>
      </div>
    </div>

    <div class="p-10 m-1 b-t-1-869fb229">
      <div class="card-body form-row">
        <div class="col-12">
          <div class="row">
            <!-- Thông tin đơn -->
            <div class="col-md-6">
              <div class="form-detail">
                <div>
                  <h5 class="card-title">Thông tin đơn</h5>

                  <div class="form-group row">
                    <label class="col-sm-4 col-form-label">Mã đơn</label>
                    <div class="col-sm-8">
                      <p class="form-control-plaintext">{{ detail.orderCode }}</p>
                    </div>
                  </div>

                  <div class="form-group row">
                    <label class="col-sm-4 col-form-label">Đơn vị nhận hàng</label>
                    <div class="col-sm-8">
                      <p class="form-control-plaintext">{{ detail.agentName }}</p>
                    </div>
                  </div>

                  <div class="form-group row">
                    <label class="col-sm-4 col-form-label">Địa chỉ nhận hàng</label>
                    <div class="col-sm-8">
                      <p class="form-control-plaintext">{{ detail.agentAddress || '' }}</p>
                    </div>
                  </div>

                  <div class="form-group row">
                    <label class="col-sm-4 col-form-label">Người tạo</label>
                    <div class="col-sm-8">
                      <p class="form-control-plaintext">{{ detail.userCreator?.name }}</p>
                    </div>
                  </div>

                  <div class="form-group row">
                    <label class="col-sm-4 col-form-label">Ngày tạo</label>
                    <div class="col-sm-8">
                      <p class="form-control-plaintext">{{ formatDate(detail.createdTime) }}</p>
                    </div>
                  </div>

                  <div class="form-group row">
                    <label class="col-sm-4 col-form-label">Ngày nhận dự kiến</label>
                    <div class="col-sm-8">
                      <p class="form-control-plaintext">{{ formatDate(detail.estimatedTime) }}</p>
                    </div>
                  </div>

                  <div class="form-group row">
                    <label class="col-sm-4 col-form-label">Trạng thái</label>
                    <div class="col-sm-8">
                      <p class="form-control-plaintext">
                        <span
                          class="badge text-white"
                          :class="getStatusClass(detail.status, optionStatus)"
                        >
                          {{ transformStatus(detail.status) }}
                        </span>
                      </p>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-sm-4 col-form-label">Trạng thái điều chyển</label>
                    <div class="col-sm-8">
                      <p class="form-control-plaintext">
                        <span
                          class="badge"
                          :class="
                            getStatusClass(detail.orderTransferStatus, Config.statusWarehouse)
                          "
                        >
                          {{ transformStatusTransfer(detail.orderTransferStatus) }}
                        </span>
                      </p>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-sm-4 col-form-label">Trạng thái phiếu thu</label>
                    <div class="col-sm-8">
                      <p class="form-control-plaintext">
                        <span
                          class="badge"
                          :class="`badge-${getStatusClass(detail.receiptOrderStatus, Config.statusTranferAgent)}`"
                        >
                          {{ transformStatusReceipt(detail.receiptOrderStatus) }}
                        </span>
                      </p>
                    </div>
                  </div>

                  <div class="form-group row">
                    <label class="col-sm-4 col-form-label">Ghi chú</label>
                    <div class="col-sm-8">
                      <p class="form-control-plaintext">{{ detail.note || '' }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-detail">
                <div>
                  <h5 class="card-title">Xử lý</h5>

                  <div class="form-group row">
                    <label class="col-sm-4 col-form-label">Người phụ trách (NextPay)</label>
                    <div class="col-sm-8">
                      <p class="form-control-plaintext">{{ detail?.keeper?.name }}</p>
                      <p class="form-control-plaintext">{{ detail?.keeper?.email }}</p>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-sm-4 col-form-label">Vùng</label>
                    <div class="col-sm-8">
                      <p class="form-control-plaintext">{{ detail?.keeper?.regionName }}</p>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Bảng danh sách thiết bị -->
              <div class="mt-3">
                <div class="form-detail">
                  <table class="table table-bordered">
                    <thead>
                      <tr>
                        <th>Loại thiết bị</th>
                        <th>Số lượng</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in detail.orderDetail" :key="index">
                        <td>{{ item.categoryName }}</td>
                        <td>{{ item.quantity }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <!-- Lịch sử -->
            <div class="col-md-6 pl-2">
              <div class="form-detail">
                <div>
                  <h5 class="card-title">Lịch sử</h5>

                  <div class="timeline2">
                    <!-- Cập nhật đơn đặt hàng -->
                    <div
                      class="timeline-item"
                      v-for="(item, index) in detail.orderHistory || []"
                      :key="index"
                    >
                      <div class="timeline-date">{{ formatDate(item.createdTime) }}</div>
                      <div class="timeline-content">
                        <div class="timeline-title">{{ item.description }}</div>
                        <a
                          target="_blank"
                          :href="`/transfer-warehouse/detail/${detail?.orderTransferId}`"
                          v-if="item.reasonReject"
                          class="timeline-description text-primary"
                        >
                          {{ item.reasonReject }}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="notiModal">
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">Thông báo</h5>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    @click="notiModal = false"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body text-center">
                  <img :src="iconNoti" alt="icon-successs" />
                  <h2 class="f18 py-3">{{ msgNoti }}</h2>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-light"
                    @click="notiModal = false"
                    data-dismiss="modal"
                  >
                    Đóng
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import Config from '@/thirdParty/config'
  import { DeviceService } from '@/services/device.service'
  import { mapGetters } from 'vuex'

  export default {
    data() {
      return {
        showLoading: false,
        dataUser: JSON.parse(localStorage.getItem('userData')) ?? {},
        id: this.$route.params.id,
        optionStatus: [...Config.satusOderForm],
        detail: {},
        notiModal: false,
        msgNoti: '',
      }
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
      isCodeType() {
        return this.$route.query.type === 'code'
      },
    },
    created() {
      this.fetchData()
    },

    methods: {
      showSuccess(message) {
        this.notiModal = true
        this.iconNoti = require('@/assets/img/noti-success2.svg')
        this.msgNoti = message
      },
      showErr(message) {
        this.notiModal = true
        this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
        this.msgNoti = message
      },
      getStatusName(status) {
        const found = this.optionStatus.find(option => option.id === status)
        return found ? found.text : status
      },
      formatDate(timestamp) {
        if (!timestamp) return ''
        const date = new Date(timestamp)
        return `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getFullYear()}`
      },

      transformStatus(status) {
        const found = this.optionStatus.find(option => option.id === status)
        return found ? found.text : status
      },
      transformStatusTransfer(status) {
        const found = Config.statusWarehouse.find(option => option.id === status)
        return found ? found.text : status
      },

      transformStatusReceipt(status) {
        const found = Config.statusTranferAgent.find(option => option.id === status)
        return found ? found.text : status
      },

      getStatusClass(status, dataConfig) {
        const found = dataConfig.find(option => option.id === status)
        return found ? found.bgColor || found.color : ''
      },

      cancel() {
        this.$router.push('/order-form')
      },

      add() {
        this.$router.push(`/order-form-add/${this.id}`)
      },

      comfirm() {
        this.$bvModal
          .msgBoxConfirm('Bạn có chắc chắn muốn xác nhận đơn đặt hàng này?', {
            title: 'Xác nhận đơn đặt hàng',
            okTitle: 'Xác nhận',
            cancelTitle: 'Huỷ',
          })
          .then(async value => {
            if (value) {
              this.add()
            }
          })
          .catch(() => {})
      },
      cancelTransfer() {
        this.$bvModal
          .msgBoxConfirm('Bạn có chắc chắn muốn huỷ đơn đặt hàng này?', {
            title: 'Xác nhận huỷ đơn đặt hàng',
            okTitle: 'Xác nhận',
            cancelTitle: 'Huỷ',
          })
          .then(async value => {
            if (value) {
              this.showLoading = true
              try {
                const res = await DeviceService.CancelOrder({
                  id: this.id,
                })

                if (res.code === 1000) {
                  this.showSuccess(`Xác nhận huỷ đơn đặt hàng ${this.detail?.orderCode} thành công`)
                  this.fetchData()
                } else {
                  this.showErr(res.message)
                }
              } catch (error) {
                this.showErr(error.message || 'Đã xảy ra lỗi khi xử lý đơn hàng')
              } finally {
                this.showLoading = false
              }
            }
          })
          .catch(() => {})
      },

      reject() {
        const h = this.$createElement
        const messageVNode = h('div', { class: 'form-group pos-relative' }, [
          h('textarea', {
            ref: 'rejectValue',
            class: 'form-control f12',
            placeholder: 'Nhập lý do từ chối',
          }),
        ])

        this.$bvModal
          .msgBoxConfirm([messageVNode], {
            title: 'Lý do từ chối',
            okTitle: 'Xác nhận',
            cancelTitle: 'Huỷ',
            okDisabled: false,
          })
          .then(async value => {
            if (value) {
              this.showLoading = true
              try {
                const res = await DeviceService.RejectOrder({
                  id: this.id,
                  reasonReject: this.$refs.rejectValue.value,
                })

                if (res.code === 1000 || res.success) {
                  this.showSuccess(`Từ chối đơn đặt hàng ${this.detail.orderCode} thành công`)
                  this.fetchData()
                } else {
                  this.showErr(res.message)
                }
              } catch (error) {
                this.showErr(error.message || 'Đã xảy ra lỗi khi xử lý đơn hàng')
              } finally {
                this.showLoading = false
              }
            }
          })
          .catch(() => {
            this.showLoading = false
          })
      },

      async fetchData() {
        try {
          this.showLoading = true
          let data

          if (this.isCodeType) {
            // Gọi API với purchaseOrderCode khi type=code
            data = await DeviceService.DetailOrderFormPartnerByCode({ code: this.id })
          } else {
            // Gọi API với id như bình thường
            data = await DeviceService.DetailOrderFormPartner({ id: this.id })
          }

          if (data.success || data.code === 1000) {
            this.detail = data.data
          }
        } catch (error) {
          console.error(error)
        } finally {
          this.showLoading = false
        }
      },
    },
  }
</script>

<style scoped>
  .breadcrumb-area {
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .btn-group .btn {
    margin-left: 5px;
  }

  .timeline {
    position: relative;
    margin: 0;
    padding: 0;
  }

  .timeline-item {
    position: relative;
    padding-bottom: 20px;
    padding-left: 15px;
  }

  .timeline-date {
    position: absolute;
    right: 5px;
    top: 8px;
    color: #888;
    font-size: 0.85rem;
    z-index: 10;
  }

  .timeline-content {
    padding: 10px 15px;
    background-color: #f8f9fa;
    border-radius: 5px;
    margin-left: 10px;
    position: relative;
  }

  .timeline-content:before {
    content: '';
    position: absolute;
    top: 12px;
    left: -16px;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #007bff;
    border: 2px solid #fff;
  }

  .timeline-title {
    font-weight: bold;
    margin-bottom: 5px;
    font-size: 14px;
  }

  .timeline-description {
    font-size: 0.75rem;
    color: #666;
  }

  .card-title {
    font-weight: bold;
    border-bottom: 1px solid #eee;
    padding-bottom: 10px;
    margin-bottom: 15px;
    margin-left: 5px;
  }

  .table th {
    background-color: #f8f9fa;
  }

  .form-control-plaintext {
    font-size: 13px;
  }
</style>
